import GreenbookBookmarkList from './GreenbookBookmarkList';

export default GreenbookBookmarkList;
